import { CLOSE_IMPORT_WORKS_MODAL, IMPORT_AUDITS_OR_TSCANS_SUCCESS, OPEN_IMPORT_WORKS_MODAL } from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export default createReducer(false, {
  [OPEN_IMPORT_WORKS_MODAL]: () => true,
  [CLOSE_IMPORT_WORKS_MODAL]: () => false,
  [IMPORT_AUDITS_OR_TSCANS_SUCCESS]: () => false,
});
